// extracted by mini-css-extract-plugin
module.exports = {"slider":"Handle--slider--2tkk_"};